// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteAccount_container__JXG4B {
  max-width: 620px;
  padding: var(--space-6);
  border: 1px solid rgba(244, 67, 54, 0.32);
  border-radius: var(--radius-lg);
  background: var(--bg);
  box-shadow: var(--shadow-xs);
  box-sizing: border-box;
}

.DeleteAccount_title__LNpZr {
  margin: 0 0 var(--space-5);
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.008em;
  color: var(--text-primary);
}

.DeleteAccount_warningBox__WAsHJ {
  margin-bottom: var(--space-5);
  padding: var(--space-4);
  border-radius: var(--radius-sm);
  background: var(--surface-error);
}

.DeleteAccount_warningText__zLxA0 {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.55;
  color: #b71c1c;
}

.DeleteAccount_form__di\\+p\\+ {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.DeleteAccount_field__XcUt0 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.DeleteAccount_label__GPMkg {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--text-primary);
}

.DeleteAccount_input__euvBQ {
  width: 100%;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  line-height: 1.45;
  box-sizing: border-box;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.DeleteAccount_input__euvBQ::placeholder {
  color: var(--text-placeholder);
}

.DeleteAccount_input__euvBQ:focus,
.DeleteAccount_input__euvBQ:focus-visible {
  outline: none;
  border-color: var(--error);
  box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.14);
}

.DeleteAccount_buttonGroup__T4Lqe {
  display: flex;
  gap: var(--space-3);
}

.DeleteAccount_cancelButton__Q6FpP,
.DeleteAccount_deleteButton__eysUW {
  flex: 1 1;
  min-height: 40px;
  padding: 9px 18px;
  border-radius: var(--radius-input);
  font-family: var(--font);
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);
}

.DeleteAccount_cancelButton__Q6FpP {
  border: 1px solid var(--border-dark);
  background: var(--bg);
  color: var(--text-primary);
}

.DeleteAccount_cancelButton__Q6FpP:not(:disabled):hover {
  border-color: var(--text-secondary);
  background: var(--bg-secondary);
}

.DeleteAccount_deleteButton__eysUW {
  border: 1px solid transparent;
  background: var(--error);
  color: #fff;
}

.DeleteAccount_deleteButton__eysUW:not(:disabled):hover {
  background: #c62828;
}

.DeleteAccount_cancelButton__Q6FpP:not(:disabled):active,
.DeleteAccount_deleteButton__eysUW:not(:disabled):active {
  transform: translateY(1px);
}

.DeleteAccount_cancelButton__Q6FpP:disabled,
.DeleteAccount_deleteButton__eysUW:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.DeleteAccount_messageError__5oXXR,
.DeleteAccount_messageSuccess__3xVCz {
  margin: 0;
  padding: 9px 12px;
  border-radius: var(--radius-sm);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
}

.DeleteAccount_messageError__5oXXR {
  background: var(--surface-error);
  color: #b71c1c;
}

.DeleteAccount_messageSuccess__3xVCz {
  background: var(--surface-success);
  color: #1b5e20;
}

@media (max-width: 600px) {
  .DeleteAccount_container__JXG4B {
    padding: var(--space-5);
  }

  .DeleteAccount_buttonGroup__T4Lqe {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/DeleteAccount/DeleteAccount.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB;;mDAEiD;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;qDAEmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".container {\n  max-width: 620px;\n  padding: var(--space-6);\n  border: 1px solid rgba(244, 67, 54, 0.32);\n  border-radius: var(--radius-lg);\n  background: var(--bg);\n  box-shadow: var(--shadow-xs);\n  box-sizing: border-box;\n}\n\n.title {\n  margin: 0 0 var(--space-5);\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.008em;\n  color: var(--text-primary);\n}\n\n.warningBox {\n  margin-bottom: var(--space-5);\n  padding: var(--space-4);\n  border-radius: var(--radius-sm);\n  background: var(--surface-error);\n}\n\n.warningText {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.55;\n  color: #b71c1c;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.input {\n  width: 100%;\n  min-height: 40px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  box-sizing: border-box;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.input::placeholder {\n  color: var(--text-placeholder);\n}\n\n.input:focus,\n.input:focus-visible {\n  outline: none;\n  border-color: var(--error);\n  box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.14);\n}\n\n.buttonGroup {\n  display: flex;\n  gap: var(--space-3);\n}\n\n.cancelButton,\n.deleteButton {\n  flex: 1;\n  min-height: 40px;\n  padding: 9px 18px;\n  border-radius: var(--radius-input);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  font-weight: 700;\n  line-height: 1.4;\n  cursor: pointer;\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    border-color var(--dur-fast) var(--ease-standard);\n}\n\n.cancelButton {\n  border: 1px solid var(--border-dark);\n  background: var(--bg);\n  color: var(--text-primary);\n}\n\n.cancelButton:not(:disabled):hover {\n  border-color: var(--text-secondary);\n  background: var(--bg-secondary);\n}\n\n.deleteButton {\n  border: 1px solid transparent;\n  background: var(--error);\n  color: #fff;\n}\n\n.deleteButton:not(:disabled):hover {\n  background: #c62828;\n}\n\n.cancelButton:not(:disabled):active,\n.deleteButton:not(:disabled):active {\n  transform: translateY(1px);\n}\n\n.cancelButton:disabled,\n.deleteButton:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.messageError,\n.messageSuccess {\n  margin: 0;\n  padding: 9px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n}\n\n.messageError {\n  background: var(--surface-error);\n  color: #b71c1c;\n}\n\n.messageSuccess {\n  background: var(--surface-success);\n  color: #1b5e20;\n}\n\n@media (max-width: 600px) {\n  .container {\n    padding: var(--space-5);\n  }\n\n  .buttonGroup {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeleteAccount_container__JXG4B`,
	"title": `DeleteAccount_title__LNpZr`,
	"warningBox": `DeleteAccount_warningBox__WAsHJ`,
	"warningText": `DeleteAccount_warningText__zLxA0`,
	"form": `DeleteAccount_form__di+p+`,
	"field": `DeleteAccount_field__XcUt0`,
	"label": `DeleteAccount_label__GPMkg`,
	"input": `DeleteAccount_input__euvBQ`,
	"buttonGroup": `DeleteAccount_buttonGroup__T4Lqe`,
	"cancelButton": `DeleteAccount_cancelButton__Q6FpP`,
	"deleteButton": `DeleteAccount_deleteButton__eysUW`,
	"messageError": `DeleteAccount_messageError__5oXXR`,
	"messageSuccess": `DeleteAccount_messageSuccess__3xVCz`
};
export default ___CSS_LOADER_EXPORT___;
